import { Injectable } from '@angular/core';

import { BaseComponentResolver } from '@services/_base/base-component-resolver/base-component-resolver';
import { MediaComponentResolver } from '@services/resolvers/component-resolvers/media-component/media-component-resolver';
import { SpsLogger } from '@lib/utils';

import { CmsComponentConfig, CmsComponentNodeData, MediaSlider } from '@models/interfaces';
import { ParagraphSliderData, ParagraphSliderItemData } from '@generated/content';

@Injectable({
  providedIn: 'root',
})
export class MediaSliderComponentResolver extends BaseComponentResolver {
  static override instance: MediaSliderComponentResolver;
  private readonly componentType = MediaSlider.TypeEnum;
  constructor() {
    super();
  }

  static getInstance(): MediaSliderComponentResolver {
    return (MediaSliderComponentResolver.instance ||= new MediaSliderComponentResolver());
  }

  public override resolveComponentConfig(
    node: ParagraphSliderData,
    nodePageData: CmsComponentNodeData[]
  ): CmsComponentConfig<MediaSlider.ComponentConfig> | null {
    this.nodePageData = nodePageData;

    const slides = this.buildSlides(node);

    return { componentType: this.componentType, config: { slides } };
  }

  buildSlides(node: ParagraphSliderData): MediaSlider.SlideConfig[] {
    if (!node.relationships.field_slideritem.data) {
      return null;
    }

    let nodes: ParagraphSliderItemData[];

    try {
      nodes = node.relationships.field_slideritem.data.map(node => this.getNode<ParagraphSliderItemData>(node.id, node.type));
    } catch (e) {
      SpsLogger.warn(e);
      return null;
    }

    const mediaResolver = MediaComponentResolver.getInstance();

    return nodes
      .map(node => {
        const componentConfig = mediaResolver.resolveComponentConfig(node, this.nodePageData);

        return {
          ...componentConfig,
          headline: node.attributes.field_headline_slideritem ?? '',
          description: node.attributes.field_description_slideritem?.value ?? '',
        };
      })
      .reduce(
        (slideConfigs, mediaConfig) => [
          ...slideConfigs,
          { ...mediaConfig.config, headline: mediaConfig.headline, description: mediaConfig.description },
        ],
        []
      );
  }
}
